import React from "react";

export const InputArea = ({ bg, inputBg, borderColor, textColor, brand, suggestions, buttonBg,searchbarBg }) => (
  <div
    style={{
      padding: "8px 10px",
      borderTop: `1px solid ${borderColor}`,
      background: bg,
      flexShrink: 0,
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        background: searchbarBg,
        border: `1px solid ${borderColor}`,
        borderRadius: 10,
        padding: "5px 8px",
      }}
    >
      <div style={{ flex: 1, fontSize: 12, color: textColor, opacity: 0.45 }}>
        Type your message…
      </div>
      <div
        style={{
          width: 26,
          height: 26,
          borderRadius: 7,
          background: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#111111",
          fontSize: 12,
          flexShrink: 0,
        }}
      >
        ➤
      </div>
    </div>

    <div
      style={{
        display: "flex",
        gap: 5,
        marginTop: 6,
        flexWrap: "wrap",
      }}
    >
      {(suggestions || ["What are your hours?", "Pricing", "Support"]).map((q) => (
        <span
          key={q}
          style={{
            fontSize: 10,
            padding: "2px 8px",
            borderRadius: 6,
            background: buttonBg,
            color: "#ffffff",
            whiteSpace: "nowrap",
            opacity: 0.8,
          }}
        >
          {q}
        </span>
      ))}
    </div>
  </div>
);